var _defs, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhitepaperIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M351.673 382.938l-.766.643L93.792 77.163l.766-.643zM313.151 352.602l-.766.643L55.27 46.827l.766-.643z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.014,
    cy: 120.337,
    r: 71.5,
    transform: "rotate(140 117.014 120.337)",
    stroke: "#4A6FA5"
  })));
}

var MemoSvgWhitepaperIllustration = /*#__PURE__*/React.memo(SvgWhitepaperIllustration);
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDQwMCA0MzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjM1MS42NzMiIHk9IjM4Mi45MzgiIHdpZHRoPSIxIiBoZWlnaHQ9IjQwMCIgdHJhbnNmb3JtPSJyb3RhdGUoMTQwIDM1MS42NzMgMzgyLjkzOCkiIGZpbGw9IiMxNDE0MTQiLz4KPHJlY3QgeD0iMzEzLjE1MSIgeT0iMzUyLjYwMiIgd2lkdGg9IjEiIGhlaWdodD0iNDAwIiB0cmFuc2Zvcm09InJvdGF0ZSgxNDAgMzEzLjE1MSAzNTIuNjAyKSIgZmlsbD0iIzE0MTQxNCIvPgo8Y2lyY2xlIGN4PSIxMTcuMDE0IiBjeT0iMTIwLjMzNyIgcj0iNzEuNSIgdHJhbnNmb3JtPSJyb3RhdGUoMTQwIDExNy4wMTQgMTIwLjMzNykiIHN0cm9rZT0iIzRBNkZBNSIvPgo8L3N2Zz4K";
export { MemoSvgWhitepaperIllustration as ReactComponent };